'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleUGCForm = require('./components/SimpleUGCForm');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SimpleUGCForm).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/simple-ugc-form/index.js
// module id = 231
// module chunks = 4